import { MISMATCH_SAVE } from './actions.type';

import {
  MISMATCH_AREA_MODE_ENABLED,
  MISMATCH_POINT_MODE_ENABLED,
  MISMATCH_OBJECTS_MODE_ENABLED,
  MISMATCH_DISABLE_MODES,
  MISMATCH_AREA_SET,
  MISMATCH_POINT_SET,
  MISMATCH_OBJECTS_SET,
  WINDOW_API_ERROR_SHOW
} from './mutations.type';

import { Api as MismatchApi } from '../api/api-zgloszenie-rozbieznosci';

const mismatchApi = new MismatchApi();

const initialState = {
  mismatchAreaModeEnabled: false,
  mismatchPointModeEnabled: false,
  mismatchObjectsModeEnabled: false,
  mismatchAreaFeatures: null,
  mismatchPointFeatures: null,
  mismatchObjectsFeatures: null
};

const state = Object.assign({}, initialState);
const _this = this;
export const actions = {
  async [MISMATCH_SAVE](context, args) {
    try {
      var result = await mismatchApi.postZgloszeniaRozbieznosci(
        {
          wso2_id: args.wso2_id,
          orgid: args.orgid,
          form: args.mismatchObject
        },
        { jsonData: true }
      );

      if (result && result.body.id) {
        return true;
      }
      return false;
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
      return false;
    }
  }
};

const mutations = {
  [MISMATCH_OBJECTS_MODE_ENABLED](state) {
    state.mismatchAreaModeEnabled = false;
    state.mismatchPointModeEnabled = false;
    state.mismatchObjectsModeEnabled = true;
  },
  [MISMATCH_POINT_MODE_ENABLED](state) {
    state.mismatchAreaModeEnabled = false;
    state.mismatchObjectsModeEnabled = false;
    state.mismatchPointModeEnabled = true;
  },
  [MISMATCH_AREA_MODE_ENABLED](state) {
    state.mismatchObjectsModeEnabled = false;
    state.mismatchPointModeEnabled = false;
    state.mismatchAreaModeEnabled = true;
  },
  [MISMATCH_DISABLE_MODES](state) {
    state.mismatchObjectsModeEnabled = false;
    state.mismatchPointModeEnabled = false;
    state.mismatchAreaModeEnabled = false;
  },
  [MISMATCH_AREA_SET](state, value) {
    state.mismatchAreaFeatures = value;
  },
  [MISMATCH_POINT_SET](state, value) {
    state.mismatchPointFeatures = value;
  },
  [MISMATCH_OBJECTS_SET](state, value) {
    state.mismatchObjectsFeatures = value;
  }
};

const getters = {
  mismatchObjectsModeEnabled(state) {
    return state.mismatchObjectsModeEnabled;
  },
  mismatchPointModeEnabled(state) {
    return state.mismatchPointModeEnabled;
  },
  mismatchAreaModeEnabled(state) {
    return state.mismatchAreaModeEnabled;
  },
  mismatchAreaFeatures(state) {
    return state.mismatchAreaFeatures;
  },
  mismatchPointFeatures(state) {
    return state.mismatchPointFeatures;
  },
  mismatchObjectsFeatures(state) {
    return state.mismatchObjectsFeatures;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
